import React from 'react';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../../Components/helper';

function InstructionTableGroup({
  InstructionsData,
  handleCheck,
  handleCheckAll,
  isAllInstructionChecked,
  checkedIds,
  handleDelete,
  isPageDisable,
  CareDeleteAccess,
}) {
  const { t } = useTranslation('common');

  return (
    <div className="table-responsive">
      <table className="table custom-table layout-fixed">
        <thead>
          <tr>
            <th className="w-80px w-xs-40px">
              <div className="checkbox-label no-label margin-auto">
                <input
                  type="checkbox"
                  name="check_all_grp_instruction"
                  id="check_all_grp_instruction"
                  onChange={(e) => handleCheckAll(e)}
                  checked={isAllInstructionChecked}
                  disabled={isPageDisable}
                />
                <label htmlFor="check_all_grp_instruction" className="chklabel">
                  <span />
                </label>
              </div>
            </th>
            <th className="w-300px w-xs-150px">{t('CARE_LABELS.GROUP.INSTRUCTION_TABLE_GROUP.CODE')}</th>
            <th className="w-300px">{t('CARE_LABELS.GROUP.INSTRUCTION_TABLE_GROUP.DESCRIPTION')}</th>
            <th className="w-200px">{t('CARE_LABELS.GROUP.INSTRUCTION_TABLE_GROUP.CARE_TYPE')}</th>
            {CareDeleteAccess && <th className="w-80px">{t('CARE_LABELS.GROUP.INSTRUCTION_TABLE_GROUP.ACTION')}</th>}
          </tr>
        </thead>
        <tbody>
          {checkArray(InstructionsData) ? (
            InstructionsData.map((element, i) => {
              return (
                <tr key={element._id}>
                  <td>
                    <div className="checkbox-label no-label margin-auto">
                      <input
                        type="checkbox"
                        id={`check_grp_instruction_${i}`}
                        onChange={(e) => handleCheck(e, element._id)}
                        checked={checkedIds.includes(element._id)}
                        disabled={isPageDisable}
                      />
                      <label htmlFor={`check_grp_instruction_${i}`} className="chklabel">
                        <span />
                      </label>
                    </div>
                  </td>
                  <td>{element.code}</td>
                  <td>{element.description}</td>
                  <td>{element.careType}</td>
                  {CareDeleteAccess && (
                    <td>
                      <div className="d-flex align-items-center">
                        <button
                          title={t('CARE_LABELS.GROUP.INSTRUCTION_TABLE_GROUP.DELETE')}
                          type="button"
                          disabled={isPageDisable}
                          onClick={() => handleDelete(element?._id)}
                          className="filter-btn filter-button_delete"
                        >
                          <i className="icon-delete" />
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="4" className="text-center">
                {t('CARE_LABELS.GROUP.INSTRUCTION_TABLE_GROUP.NO_INSTRUCTION_FOUND')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default InstructionTableGroup;
